import ChangePasswordLoggedIn from "./changePasswordLoggedIn";
import SettingsPanel from "../../components/SettingsPanel";

const ManageUserPassword = () => {
  return (
    <SettingsPanel title="Passwords" description="Change your account password.">
      <div>
        <ChangePasswordLoggedIn page={"settingsUserProfileManagePassword"} />
      </div>
    </SettingsPanel>
  );
};

export default ManageUserPassword;
